import React, { useEffect, useState } from "react";
import {
  ViedocButtonElement,
  ViedocDialogElement,
  ViedocMenuItemElement,
  ViedocSelectElement,
} from "../../../../../secure/elements/ViedocReactElements";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../shared/Loader/Loader";
import _ from "underscore";
import * as templateActions from "../../../../../store/actions/templateActions";

const EditStructure = ({ setIsStructureEditVisible }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    isTmfStructDetailsLoading,
    structurename,
    tmfmodelversion,
    tmfStructureData,
    structureversion
  } = useSelector((store) => store.template);

  const { apiInitConfigObj } = useSelector((store) => store.zone);

  const [structureName, setStructureName] = useState(structurename);
  const [modelVersion, setModelVersion] = useState(tmfmodelversion);

  const [isTouched, setIsTouched] = useState(false);

  useEffect(() => {
    setStructureName(structurename);
    setModelVersion(tmfmodelversion);
  }, [structurename, tmfmodelversion]);

  useEffect(() => {
    if (structureName === structurename && modelVersion === tmfmodelversion) {
      setIsTouched(false);
    } else {
      setIsTouched(true);
    }
  }, [modelVersion, structureName, structurename, tmfmodelversion]);

  const onHide = () => {
    setIsStructureEditVisible(false);
    const updateTmfStructureDetails = {
      structurename: structurename,
      structurenamewithversion: structureversion,
      tmfmodelversion: "",
    }
    dispatch(templateActions.getTmfStructDetailsSuccess(updateTmfStructureDetails))
    setModelVersion("");
  };

  const spanFunc = () => {
    return <span style={{ color: "#CC4E00" }}>*</span>;
  };

  const saveStructureChangeHandler = () => {
    let requestPayload = {
      LastModifiedOn: tmfStructureData.lastmodifiedon,
      StructureName: structureName,
      TMFVersion: modelVersion,
    };
    onHide();
    dispatch(templateActions.saveTmfStructureDetails(requestPayload));
  };

  const renderStructureHeader = () => {
    return (
      <header className="pl-10" slot="header">
        <p className="f21 mt-5">{t("ADMIN.ADMINTAB_EDITSTRUCTURE")}</p>
        <div className="header-button">
          <ViedocButtonElement
            size="small"
            variant="neutral"
            disabled={!isTouched || _.isEmpty(structureName)}
            onClick={saveStructureChangeHandler}
            title={t("TMF.REVIEWPOPUP_READY")}
          >
            {t("TMF.REVIEWPOPUP_READY")}
          </ViedocButtonElement>
        </div>
      </header>
    );
  };

  const renderStructureDetails = () => {
    return (
      <div className="structure-changes-body">
        <div className="structure-fields">
          <label>
            {t("ADMIN.TEXT_STRUCTURENAME")}
            {spanFunc()}
          </label>
          <viedoc-textfield class="w-436" size="small" variant="outline">
            <input
              type="text"
              value={structureName}
              onChange={(e) => setStructureName(e.target.value)}
            />
          </viedoc-textfield>
        </div>
        <div className="structure-fields">
          <label>
            {t("ADMIN.TEXT_TMFMODELVERSION")}
            {spanFunc()}
          </label>

          <ViedocSelectElement
            value={modelVersion}
            size="small"
            onChange={(e) => setModelVersion(e.target.value)}
            title={modelVersion}
          >
            {apiInitConfigObj.tmfmodelversion.map((version, index) => (
              <ViedocMenuItemElement key={index} value={version} title="">
                {version}
              </ViedocMenuItemElement>
            ))}
          </ViedocSelectElement>
        </div>
      </div>
    );
  };

  return (
    <ViedocDialogElement
      size="small"
      open
      preventCloseByClick
      class="edit-artifact-popup"
      onHide={() => onHide()}
    >
      {renderStructureHeader()}
      {isTmfStructDetailsLoading ? (
        <Loader width={"100%"} borderRadius />
      ) : (
        renderStructureDetails()
      )}
    </ViedocDialogElement>
  );
};

export default EditStructure;
